import { useLinesStore } from "../../stores/useLinesStore";

export function useKmTotalRota(codigo) {

    return useLinesStore(
        state => {

            const metrosTotalRota =
                state.metrosTotalRotaMap.get(
                    String(
                        codigo || ''
                    ).trim()
                ) ?? 0;

            return Math.round(metrosTotalRota / 1000);

        }
    );

}